import Vue from 'vue'
import App from './App.vue'
import router from './router'
import router1 from './router/index1'
import router2 from './router/index2'
import store from './store'
//111
import './plugins/vant'
import './styles/index.less'

import 'amfe-flexible'
import day from './utils/day'
import '../smartcitysdk1'
import xh from 'u-xymm/dist/xinhua-sdk';
import { getSkillType } from '@/api/home'
Vue.prototype.isInSmartCityApp = SmartCity.isSmartCityApp()
Vue.prototype.xh = xh
if (process.env.NODE_ENV === 'development') {
    Vue.prototype.isInSmartCityApp = true;
}

if (process.env.NODE_ENV !== 'production' || window.location.href.indexOf('_debug=jsdev') > -1) {
    const VConsole = require('vconsole')
    new VConsole()
}

;(function () {
    getSkillType().then((res) => {
        let data = res.data
        console.log('getSkillType', data)

        if (data.code == 200) {
            let routerFile = router
            //实物
            if (data.data === 0) {
                routerFile = router
                // 虚拟
            } else if (data.data === 1) {
                routerFile = router1
            } else {
                routerFile = router2
            }

            new Vue({
                router: routerFile,
                store,
                render: (h) => h(App),
            }).$mount('#app')
        }
    })
})()

Vue.config.productionTip = false
Vue.use(day)
